function culcPageTable<T>(data: T[], from: number, to: number): T[] {
    return data.slice(from, to + 1);
}

export default culcPageTable;